import { useState } from "react";
import { Button } from "@/components/ui/button";
import { SectionShell } from "./SectionShell";
import { paragraphs } from "./proposalUtils";

/** 04 · Vilkår: plain, readable terms; long texts are truncated with a reveal. */
export const ProposalTerms = ({ data }) => {
  const paras = paragraphs(data.terms);
  const [all, setAll] = useState(false);
  if (!paras.length) return null;
  const limit = 6;
  const shown = all || paras.length <= limit ? paras : paras.slice(0, limit);
  return (
    <SectionShell id="vilkar" no="04" title="Vilkår" lede="Betingelsene som gjelder for leveransen. Spesielle forhold avtales skriftlig.">
      <ol className="max-w-[680px] space-y-3 text-[14.5px] leading-7 text-foreground/85" data-testid="proposal-terms">
        {shown.map((t, i) => (
          <li key={i} className="grid grid-cols-[2rem_1fr] gap-2">
            <span className="font-mono text-[12.5px] tabular text-muted-foreground pt-1">{String(i + 1).padStart(2, "0")}</span>
            <span>{t}</span>
          </li>
        ))}
      </ol>
      {paras.length > limit && (
        <Button variant="ghost" className="mt-4 h-9 px-3" onClick={() => setAll((a) => !a)} data-testid="proposal-terms-toggle">{all ? "Vis færre" : `Vis alle ${paras.length} punkter`}</Button>
      )}
    </SectionShell>
  );
};
